<template src="../layouts/DynamicDashboardLayout.html"></template>

<script setup>
    import { 
        ref
        , computed
        , onMounted
        , onUnmounted 
    }                        from 'vue'
    import StatWidget        from '../widgets/StatWidget.vue'
    import DynamicFormLayout from './DynamicFormLayout.vue'
    import ChartWidget       from '../widgets/ApexChartWidget.vue'
    import { Vue3Lottie }    from 'vue3-lottie'
    import lottieLoading     from '@/assets/loading.json'

    import { AgGridVue }     from 'ag-grid-vue3'
    import { 
          LightAgGrid
        , LightAgGridDark
        , paginationPageSize
        , paginationPageSizeSelector
        , defaultColDef
    }                        from '@/utils/agGrid.js'
    import formConfigJson    from '@/apps/jsonForm/dashboard-home.json'
    import { 
        HitBackEnd
        , ReArrange, getSectionWidthStyle
    }                        from '@/utils/formUtilsNew.js'
    import { GridGenerator } from '@/utils/GridGenerator.js'
    import DetailModal       from '@/utils/DetailModal.vue'
    import moment from 'moment'

    // import ChartWidget                                  from '../widgets/ChartWidget.vue'
    // import ChartWidget                                  from '../widgets/Vue-eChartWidget.vue'

    const rowData             = ref([]);
    const columnDefs          = ref([]);
    const hiddenFields        = ref([]);
    const customColumns       = ref({});
    const customFormats       = ref({});
    const rawMetrics          = ref({})
    const isLoading           = ref(false)

    // Modal State
    const isModalOpen         = ref(false)
    const selectedRowDetails  = ref({})

    function formatTitle(key) {
    return key
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase())
    }

    defineProps({
        config: {
            type: Object,
            default: () => ({})
        }
    })

    // Dark Mode Handling
    const isDark         = ref(document.documentElement.classList.contains('dark'))
    let   observer       = null

    // Switch grid to dark or light
    const AgGridDark     = computed(() => isDark.value ? LightAgGridDark : LightAgGrid)

    const onRowDoubleClicked  = (event) => {
        selectedRowDetails.value = event.data
        isModalOpen.value        = true
    }

    // Try to trigger single click !!!
    const onRowSingleClicked = (event) => {
        selectedRowDetails.value = { ...event.data }
        // Implement to right chart if id is equal with json resp from api 
        if (event.data) {
            Object.assign(formData, event.data)
        }
        isModalOpen.value        = false
    }

    const closeModal = () => { isModalOpen.value = false }

    const onRowSaved = (updatedRow) => {
        const index = rowData.value.findIndex(row => row.id === updatedRow.id)
        if (index !== -1) {
            rowData.value[index] = { ...updatedRow }
            rowData.value        = [...rowData.value]
        }
    }


    // WEB SOCKET HERE _________________________________________________________________________
    let socket = null

    const handleLiveChartStream = (incomingData) => {
        // 1. Locate the specific chart widget by key or ID
        const chartWidget = parsedWidgets.value.find(w => w.key === incomingData.targetKey)
        if (!chartWidget || !chartWidget.value) return

        const { timestampLabel, seriesValues } = incomingData
        const MAX_POINTS = 20 // Keep x-axis clean

        // 2. Push new X-Axis time label & shift oldest if exceeding limit
        chartWidget.value.labels.push(timestampLabel)
        if (chartWidget.value.labels.length > MAX_POINTS) {
            chartWidget.value.labels.shift()
        }

        // 3. Update dataset values across matching series
        chartWidget.value.datasets.forEach((ds, idx) => {
            const newValue = seriesValues[idx] ?? seriesValues[ds.label] ?? 0
            ds.data.push(newValue)

            if (ds.data.length > MAX_POINTS) {
                ds.data.shift()
            }
        })
    }

    const setupWebSocket = () => {
        const wsTarget = "ws://localhost:8768/ws/chart"
            socket   = new WebSocket(wsTarget)

        socket.onmessage = (event) => {
            try {
                const payload = JSON.parse(event.data)
                // Incoming Payload Format Example:
                // { targetKey: 'line-chart-1', timestampLabel: '11:15:30', seriesValues: [150, 420] }
                
                if (payload.targetKey) {
                    handleLiveChartStream(payload)
                }
            } catch (err) {
                console.error('WS Payload Parsing Error:', err)
            }
        }
    }
    // WEB SOCKET HERE _________________________________________________________________________


    const old_parsedWidgets = computed(() => {
        return Object.entries(rawMetrics.value).map(([key, val]) => {
            const title = formatTitle(key)
            let DrawChart = {
                key , title , type: 'stat' , size: 'sm'
                // If you want show currency , name it as revenue or price or something you want to
                // , format: key.includes('revenue') || key.includes('price') ? 'currency' : 'number'
                , format: 'number'
                , value : val
                , icon  : "null"
            }

            if (val && typeof val === 'object' && val.labels && val.datasets) {
                const isFullWidth = val.chart === 'line' || val.chart === 'bar'
                DrawChart = { key , title, value: val
                                , type : 'chart'
                                , size : isFullWidth ? 'lg': 'sm'
                }
            } else {
                if (typeof val === 'string' ) {
                    DrawChart = { key , title, value: val
                                , size: 'sm', type: 'stat'
                                , icon : "null"
                                }
                } else if (typeof val === 'object' ) {
                    let CardFormat = parseFloat(val.value) > 0 ? "number" :"text"
                    DrawChart = { key , title, value: val.value
                                , size: 'sm', type: "stat", format : CardFormat
                                , icon : val.icon
                                }
                }
            }
            // console.log("🚀 ~ file: DynamicDashboardLayout.vue:96 ~ DrawChart:", DrawChart)
            return DrawChart
        })
    })

    const parsedWidgets = computed(() => {
        return Object.entries(rawMetrics.value).map(([key, val]) => {
            const title = formatTitle(key)
            
            // Extract size from object payload if provided (e.g. "half", "1/3", "2/3", "full", "lg", "sm")
            const customSize = typeof val === 'object' && val?.size ? val.size : null;

            let DrawChart = {
                    key, title, type: 'stat', size: customSize || 'sm'
                    , format: 'number'
                    , value : val
                    , icon  : "null"
            }

            if (val && typeof val === 'object' && val.labels && val.datasets) {
                const isFullWidth = val.chart === 'line' || val.chart === 'bar'
                DrawChart = { 
                    key, title, value: val
                    , type : 'chart'
                    , size : customSize || (isFullWidth ? 'lg' : 'sm')
                }
            } else {
                if (typeof val === 'string') {
                    DrawChart = { 
                        key, title, value: val
                        , size: customSize || 'sm', type: 'stat'
                        , icon : "null"
                    }
                } else if (typeof val === 'object') {
                    let CardFormat = parseFloat(val.value) > 0 ? "number" : "text"
                    DrawChart = { 
                        key, title, value: val.value
                        , size: customSize || 'sm', type: "stat", format: CardFormat
                        , icon : val.icon
                    }
                }
            }
            return DrawChart
        })
    })

    const getFlexStyle = (size) => {
        switch (size) {
            case 'sm'   : return 'flex-1 min-w-[280px] max-w-full'
            case 'md'   : return 'flex-[2_2_400px] min-w-[320px] max-w-full'
            case 'lg'   : return 'flex-[3_3_600px] min-w-[350px] max-w-full'
            case 'half' : return 'w-full md:w-[calc(50%-0.5rem)] flex-none'
            case '1/3'  : return 'w-full md:w-[calc(33.333%-0.67rem)] flex-none'
            case '2/3'  : return 'w-full md:w-[calc(66.666%-0.33rem)] flex-none'
            case 'full' : return 'w-full flex-none'
            default     : return 'flex-1 min-w-[280px] max-w-full'
        }
    }

    async function fetchDashboardData() {
        isLoading.value = true
        // Hit Server 
        /*
            let result;
            try {
                    const urlTarget = "/api/dashboard/monthly"
                    const res = await HitBackEnd(urlTarget, "post", payload)

                    // Handle server non-200 responses (404, 500, etc.)
                    if (!res.ok) {
                        throw new Error(`Server error ${res.status}: ${res.statusText}`)
                    }
                    result = await res.json()
            } catch (err) {
                // setError(err.message || 'Failed to search data')
            } finally {
                // setLoading(false)
            }
        */
        // Example response will be process
        // let result = {
        //     statusCode: 200,
        //     message   : "Dashboard metrics loaded successfully",
        //     data      : {
        //         total_users_active  : {value : 115_420, icon:"pi-amazon rotate-30"},
        //         total_users_passive : 420,
        //         total_enroll        : 15_420,
        //         total_authentication: {value : 315_420, icon:"pi-users"},
        //         total_usage         : 15_420,
        //         total_revenue       : 850_000_000,
        //         total_sales         : 150_000_000,
        //         total_expense       : {value : 10_000   , icon:"pi-dollar"},
        //         server_status       : {value : "active", icon:"pi-heart-fill -rotate-30"},
        //         device_dist         : {
        //             chart   : "pie",
        //             size    : "half",
        //             labels  : ["Android", "iOS", "Web","Other"],
        //             datasets: [{
        //                 data: [150, 230, 420, 330]
        //                 , backgroundColor: ["#3b82f6", "#10b981", "#f59e0b"] // Remove this !! if you want to random color
        //             }]
        //         },
        //     }            
        // }
        // result.data.total_usage_api = result.data.total_users_active + result.data.total_sales

        const profileRaw = localStorage.getItem('user_profile')
        const profile    = JSON.parse(profileRaw)

        const endPoint = '/api/webcms/dashboard'
        const payload  = {
            "username"      : profile.username
            , "date_start"  : moment().add(-7, 'days').format('YYYY-MM-DD')
            , "date_end"    : moment().format('YYYY-MM-DD')
        }

        try {
            const response = await HitBackEnd(endPoint, "post", payload)

            // Handle server non-200 responses (404, 500, etc.)
            if (!response.ok) {
                throw new Error(`Server error ${response.status}: ${response.statusText}`)
            }

            const result        = await response.json()
            const workingData   = result.data.working_data[0]
            const dataAttendant = result.data.attendant?.[profile.username] ?? []
            // const dataGrid      = ref([])
            // console.log("🚀 ~ fetchDashboardData ~ dataGrisd:", dataGrid.value)
            // const newTestingOrder = [
            //       "fullname"
            //     , "attend_date" 
            //     , "in_time"
            //     , "out_time"
            //     , "alias"
            // ]
            // const testing       = await ReArrange(newTestingOrder, dataAttendant);

            // dataAttendant.forEach((data) => {
            //     const newFormat = {
            //           "fullname"   : data.fullname
            //         , "attend_date": moment(data.attend_date).format('LL')
            //         , "in_time"    : data.in_time
            //         , "out_time"   : data.out_time
            //         , "alias"      : data.alias
            //     }
            //     dataGrid.value.push(newFormat)
            // })

            // NOW RENDERING INTO AG-GRID !!!!! ________________________________________________
                // LET ROCK THE GRID !! _________________________________
                if (dataAttendant && Array.isArray(dataAttendant)) {
                    rowData.value = dataAttendant;
                    // console.log("🚀 ~ handleSearch ~ rowData.value:", rowData.value)

                    // if you want to hide something, field are hidden mean readonly 
                    hiddenFields.value = [
                          "="
                        , "fullname"
                        , "attend_date"
                        , "in_time"
                        , "out_time"
                        , "alias"
                    ]

                    // Custom to convert specific field into human reader
                    customColumns.value = { 
                          alias       : "Status Kehadiran"
                        , fullname    : "Nama Karyawan"
                        , attend_date : "Tanggal Kehadiran"
                        , in_time     : "Jam Masuk"
                        , out_time    : "Jam Pulang"
                    }

                    // Custom format for each value
                    customFormats.value = {
                          attend_date : "tanggal"
                        , in_time        : "jam"
                        , out_time       : "jam"
                    }

                    // Explain To this 
                    columnDefs.value = GridGenerator( 
                          rowData.value
                        , customColumns.value
                        // , {}
                        , hiddenFields.value
                        , customFormats.value
                    );

                    // console.log("🚀 ~ handleSearch ~ columnDefs.value:", columnDefs.value)
                } else {
                    rowData.value = [];
                }

            // END RENDERING  INTO AG-GRID !!!!! ________________________________________________

            rawMetrics.value = {
                pending     : {value : workingData?.pending             ?? 0, icon:"pi-amazon rotate-30"},
                terlambat   : {value : workingData?.total_late          ?? 0, icon:"pi-amazon rotate-30"},
                hadir       : {value : workingData?.total_work_day      ?? 0, icon:"pi-amazon rotate-30"},
                lembur      : {value : workingData?.total_over_time_day ?? 0, icon:"pi-amazon rotate-30"},
                sisa_cuti   : {value : workingData?.permit_amount       ?? 0, icon:"pi-amazon rotate-30"},
            }
            
        } catch (error) {
            console.log("🚀 ~ fetchDashboardData ~ error:", error)
            
        }

        isLoading.value  = false
    }

    onMounted(() => {
        // setupWebSocket()
        observer = new MutationObserver(() => {
            isDark.value = document.documentElement.classList.contains('dark')
        })
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
        fetchDashboardData()
    })

    onUnmounted(() => {
        if (socket) socket.close()
    })
</script>